<div class="row-main" [class.no-checkbox]="hideCheckbox">
  <div class="cell checkbox-cell" *ngIf="!hideCheckbox" (click)="$event.stopPropagation()">
    <mat-checkbox 
      [checked]="selected"
      [indeterminate]="partiallySelected"
      (change)="onCheckboxChange($event)">
    </mat-checkbox>
  </div>
  <div class="cell order-id-cell">
    <span class="order-id-text" [matTooltip]="order.orderId">{{ order.orderId }}</span>
  </div>
  <div class="cell consignee-cell">
    <span class="consignee-text">{{ order.consigneeName }}</span>
  </div>
  <div class="cell volume-cell">
    <span class="volume-text">{{ order.totalCBM | number: '1.1-1' }} CBM</span>
  </div>
  <div class="cell weight-cell">
    <span class="weight-text">{{ order.totalWeight | number: '1.1-1' }}kg</span>
  </div>
  <div class="cell priority-cell">
    <button
      class="priority-badge"
      [ngClass]="priorityBadgeClass"
      type="button"
      disabled>
      {{ order.priority }}
    </button>
  </div>
  <div class="cell actions-cell" (click)="$event.stopPropagation()">
    <button 
      *ngIf="deletable"
      class="delete-btn"
      (click)="onDelete($event)">
      <img src="assets/booking-engine/icons/trash.svg" alt="Delete" class="delete-icon">
    </button>
    <button
      type="button"
      class="expand-btn"
      [class.expanded]="expanded"
      (click)="onExpandToggle($event)"
      [attr.aria-expanded]="expanded"
      [attr.aria-label]="expanded ? 'Collapse order details' : 'Expand order details'">
      <img
        class="arrow-icon"
        src="assets/booking-engine/icons/arrow-drop.svg"
        alt=""
        aria-hidden="true"
        width="20"
        height="20" />
    </button>
  </div>
</div>
<mat-divider *ngIf="!selected"></mat-divider>

